import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FileButton, UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useDeleteOutboundFile, useUploadOutboundFile } from "@/hooks/outbound";
import { formatFileName } from "@/utils/format";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { Button } from "@/components/button";
/** Uploads a file to S3 for an outbound document and stores its key + content type. */
export function FileUploadField(_ref) {
  var _field$max_size_mb, _field$accept$join, _field$accept;
  var field = _ref.field,
    fieldKey = _ref.fieldKey,
    value = _ref.value,
    valueName = _ref.valueName,
    setField = _ref.setField,
    workspaceId = _ref.workspaceId,
    patientId = _ref.patientId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var resetRef = useRef(null);
  var _useState = useState(null),
    fileName = _useState[0],
    setFileName = _useState[1];
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];
  var upload = useUploadOutboundFile(workspaceId, patientId);
  var remove = useDeleteOutboundFile(workspaceId);
  var maxMb = (_field$max_size_mb = field.max_size_mb) !== null && _field$max_size_mb !== void 0 ? _field$max_size_mb : 50;
  var onFile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
      var result, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setError(null);
            if (!(file.size > maxMb * 1024 * 1024)) {
              _context.n = 1;
              break;
            }
            setError(t("file_too_large", {
              defaultValue: "File exceeds ".concat(maxMb, " MB.")
            }));
            return _context.a(2);
          case 1:
            _context.p = 1;
            if (!value) {
              _context.n = 2;
              break;
            }
            _context.n = 2;
            return remove.mutateAsync(value)["catch"](function () {
              return undefined;
            });
          case 2:
            _context.n = 3;
            return upload.mutateAsync(file);
          case 3:
            result = _context.v;
            setField(fieldKey, result.s3_key);
            setField("".concat(fieldKey, "__ct"), file.type);
            setField("".concat(fieldKey, "__name"), file.name);
            setFileName(file.name);
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            setError(t("file_upload_failed", {
              defaultValue: "Upload failed. Please try again."
            }));
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 4]]);
    }));
    return function onFile(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var clear = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _resetRef$current;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            trackEvent(ANALYTICS_EVENTS.FILE_REMOVE, {
              fieldKey: fieldKey
            });
            if (!value) {
              _context2.n = 1;
              break;
            }
            _context2.n = 1;
            return remove.mutateAsync(value)["catch"](function () {
              return undefined;
            });
          case 1:
            setField(fieldKey, "");
            setField("".concat(fieldKey, "__ct"), "");
            setField("".concat(fieldKey, "__name"), "");
            setFileName(null);
            (_resetRef$current = resetRef.current) === null || _resetRef$current === void 0 || _resetRef$current.call(resetRef);
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function clear() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-1.5"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-base text-sds-base-secondary"
  }, field.label, field.required ? /*#__PURE__*/React.createElement("span", {
    className: "text-sds-urgent-secondary"
  }, " *") : null), value ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between gap-3 rounded-sds-200 border border-sds-base-default px-3 py-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex min-w-0 items-center gap-2 text-style-body-small text-sds-base-default"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPaperclip,
    className: "h-3.5 w-3.5 flex-shrink-0 text-sds-brand-default"
  }), /*#__PURE__*/React.createElement("span", {
    className: "truncate"
  }, fileName || valueName || formatFileName(value))), /*#__PURE__*/React.createElement(UnstyledButton, {
    type: "button",
    "data-testid": "file-remove-".concat(fieldKey),
    "aria-label": t("remove", {
      defaultValue: "Remove"
    }),
    onClick: clear,
    className: "text-sds-base-tertiary hover:text-sds-urgent-secondary"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faXmark,
    className: "h-3.5 w-3.5"
  }))) : /*#__PURE__*/React.createElement(FileButton, {
    resetRef: resetRef,
    accept: (_field$accept$join = (_field$accept = field.accept) === null || _field$accept === void 0 ? void 0 : _field$accept.join(",")) !== null && _field$accept$join !== void 0 ? _field$accept$join : "",
    onChange: function onChange(file) {
      trackEvent(ANALYTICS_EVENTS.FILE, {
        fieldKey: fieldKey
      });
      if (file) onFile(file);
    }
  }, function (props) {
    return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
      variant: "secondary",
      leftIcon: faPaperclip,
      disabled: upload.isLoading,
      "data-testid": "file-".concat(fieldKey)
    }), upload.isLoading ? t("uploading", {
      defaultValue: "Uploading…"
    }) : t("choose_file", {
      defaultValue: "Choose file"
    }));
  }), error ? /*#__PURE__*/React.createElement("p", {
    className: "text-style-label-base text-sds-urgent-secondary"
  }, error) : null);
}